<div class="justify-content-center">
  <mat-card *ngIf="layoutService.isMobileLayout && cartoService.showFilters" class="filter-card">
    <button mat-flat-button class="close-button" (click)="closeFilters()">Verberg filters</button>
    <app-filters></app-filters>
  </mat-card>
</div>
